const menu_ready = (callback) => {
   if (document.readyState != "loading") callback();
   else document.addEventListener("DOMContentLoaded", callback);
};

menu_ready(() => {
   const menuBurger = document.querySelector('.js-button-burger');
   const menuMobileWrapper = document.querySelector('.js-menu-wrapper');
   const menuItemsButtonDropdown = document.querySelectorAll('.wcl-button-open-submenu');
   const htmlBody = document.getElementsByTagName('body')[0];

   if (menuBurger) {
      menuBurger.addEventListener('click', function () {
         menuBurger.classList.toggle('active');
         menuMobileWrapper.classList.toggle('active');
         htmlBody.classList.toggle('overflow-hidden');
      });
   }

   if (menuItemsButtonDropdown) {
      menuItemsButtonDropdown.forEach(function (menuItemButtonDropdown) {
         menuItemButtonDropdown.addEventListener('click', function () {
            menuItemButtonDropdown.classList.toggle('active');

            const menuItemParent = menuItemButtonDropdown.closest('li');
            if (menuItemParent) {
               menuItemParent.classList.toggle('active');
            }
         });
      });
   }
});